import React from 'react';
import { Link } from 'react-router-dom';
import MembershipApplicationForm from '../components/MembershipApplicationForm';

const Membership = () => {
  const [showForm, setShowForm] = React.useState(false);

  return (
    <div className="section">
      <div className="container">
        <h1 className="section-title" style={{ textAlign: 'center' }}>Membership</h1>
        
        {!showForm ? (
          <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
            <p style={{ fontSize: '1.1rem', marginBottom: '2rem' }}>
              Become part of Nigeria's premier urological surgery association.
            </p>
            
            <div style={{ 
              backgroundColor: 'var(--light-green)', 
              padding: '2rem', 
              borderRadius: '8px', 
              marginBottom: '2rem',
              textAlign: 'left'
            }}>
              <h3 style={{ color: 'var(--primary-green)', marginBottom: '1rem' }}>Steps to Membership:</h3>
              <ol style={{ paddingLeft: '1.5rem', textAlign: 'left' }}>
                <li>Fill the application form and upload required documents</li>
                <li>An automatic email notification is sent to our official email for review of the application for approval or otherwise</li>
                <li>Once approved, payment is enabled</li>
                <li>After payment, a membership number and certificate are generated and assigned</li>
                <li>The new member will use the membership number as username</li>
              </ol>
            </div>
            
            <h3 style={{ color: 'var(--primary-green)', marginTop: '2rem' }}>Benefits of Membership</h3>
            <div style={{ textAlign: 'left', marginTop: '1rem', maxWidth: '600px', margin: '0 auto' }}>
              <ul>
                <li>Access to exclusive training programs and workshops</li>
                <li>Networking opportunities with leading surgeons</li>
                <li>Research collaboration platforms</li>
                <li>Advocacy representation at national level</li>
                <li>Access to latest urological guidelines and protocols</li>
                <li>Priority registration for conferences and events</li>
                <li>Professional development resources</li>
                <li>Discounts on NAUS events and publications</li>
              </ul>
            </div>
            
            <div style={{ marginTop: '2rem', display: 'flex', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap' }}>
              <button 
                className="btn touch-target"
                onClick={() => setShowForm(true)}
                style={{ padding: '12px 24px' }}
              >
                Apply for Membership
              </button>
              <Link to="/contact" className="btn" style={{ backgroundColor: 'var(--secondary-green)' }}>
                Contact Us
              </Link>
            </div>
          </div>
        ) : (
          <MembershipApplicationForm />
        )}
      </div>
    </div>
  );
};

export default Membership;